import { InjectionToken } from '@angular/core';
import { getDateObject } from './getDateObject';

/**
 * @description         Generate an array of years
 * @param simpleDate    Simple date format
 * @param numOfYears    Number of years to generate
 */
export const getYearOptions = (simpleDate: string, numOfYears: number): YearOption[] => {
    const dateObj = getDateObject(simpleDate);
    const years = [];

    if (!(dateObj instanceof Date)) {
        return years;
    }

    let year = dateObj.getFullYear();

    for (let i = 0; i <= numOfYears; i++) {
        years.push({
            label: year,
            value: year
        });
        year++;
    }

    return years;
};

export interface YearOption {
    label: number;
    value: number;
}
export type GetYearOptionsProvider = (simpleDate: string, numOfYears: number) => YearOption[];
export const GET_YEAR_OPTIONS =
    new InjectionToken('GET_YEAR_OPTIONS', {
        factory: () => getYearOptions
    });
